import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Menu,
  MenuItem,
  Typography,
  IconButton,
  Toolbar,
  AppBar,
  Avatar,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { logout } from 'redux/slices/authSlice';
import { useHistory } from 'react-router-dom';
import { useAuth } from 'context/auth/AuthContext';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    color: 'blue',
  },
}));

const getInitials = (user) => {
  if (!user.name) return 'BC';
  const first = user.name.split(' ').shift().toUpperCase();
  const last = user.name.split(' ').pop().toUpperCase();
  if (first === last) return first[0] + first[1];
  return first[0] + last[0];
};

export default function PrimarySearchAppBar() {
  const user = useAuth();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
    history.push('/');
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleMenuClose}>Mi perfil</MenuItem> */}
      <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" noWrap>
            Banco Columbia
          </Typography>
          <div className={classes.grow} />
          <div>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <Avatar
                variant="rounded"
                alt="username initials"
                className={classes.avatar}
              >
                {getInitials(user)}
              </Avatar>
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMenu}
    </div>
  );
}
